import React from 'react';
import cn from 'clsx';
import styles from './style.module.scss';
import Button from '@components-clean/core/button';
import { useTranslation } from '@hooks/index';

interface AddNewFilterListItemProps {
    onAddNew?: () => void;
}

const AddNewFilterListItem = ({ onAddNew }: AddNewFilterListItemProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'k-listview-item k-pos-relative k-d-flex k-align-items-center k-mb-2 !k-py-1 !k-pr-1.5 !k-pl-10 k-rounded-lg',
                styles.addItem,
            )}
        >
            <div className="k-ml-auto">
                <Button onClick={onAddNew} data-testid="add-new" primary>
                    {`+ ${t('new')}`}
                </Button>
            </div>
        </div>
    );
};

export default AddNewFilterListItem;
